import { createFileRoute } from "@tanstack/react-router";

import { ReceiptsPage } from "../../../../features/purchasing/receipts-page";

export const Route = createFileRoute("/_app/purchasing/receipts/")({ component: ReceiptsPage });
